import React, { ReactNode } from 'react'
import { Flex, csx } from '@vtex/admin-ui'
import classNames from 'classnames'

export type BottomSliderModalHeaderProps = {
  children?: ReactNode
} & React.ComponentProps<'header'>

export const BottomSliderModalHeader = ({
  children,
  className,
  ...props
}: BottomSliderModalHeaderProps) => (
  <header
    className={classNames(
      csx({
        position: 'relative',
        paddingX: '$space-6',
        paddingY: '$space-4',
        borderBottom: '$neutral',
      }),
      className
    )}
    {...props}
  >
    <Flex
      className={csx({
        justifyContent: 'space-between !important',
        alignItems: 'center !important',
      })}
    >
      {children}
    </Flex>
  </header>
)
